import React, { useEffect } from "react";
import fundacionNicanImg from "../imgs/quienes-somos/nican.jpg";
import AOS from "aos";
import "aos/dist/aos.css";
import "../styles/AboutUs.css";

function AboutUs() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <section id="about" className="about-section my-5" data-aos="fade-up">
      <div className="container h-100 d-flex align-items-center mt-5 mt-md-0">
        <div className="row w-100">
          <div
            className="col-lg-7 text-justify about-text p-3"
            data-aos="fade-right"
          >
            <h2>¿Por qué elegir Fundación Nican?</h2>
            <p>
              En Fundación Nican ayudamos a personas de Ixtapaluca, Chalco,
              Valle de Chalco y la zona oriente del Estado de México a
              desarrollar habilidades profesionales mediante cursos
              especializados en enfermería, podología clínica, quiropráctica,
              fisioterapia, masoterapia y certificaciones laborales con respaldo
              SEP-CONOCER.
            </p>
            <p>
              Nuestros programas están diseñados para que cada alumno adquiera
              conocimientos prácticos, mejore sus oportunidades laborales y
              pueda generar ingresos ayudando a otros. Formamos estudiantes con
              acompañamiento cercano, enfoque humano y preparación orientada al
              mercado laboral.
            </p>
            <p>
              Si buscas un curso de auxiliar de enfermería en Ixtapaluca, un
              diplomado en podología clínica, un diplomado en quiropráctica o
              una certificación laboral oficial, aquí encontrarás una opción
              cercana, profesional y enfocada en tu crecimiento.
            </p>
          </div>

          <div className="col-lg-5 d-none d-lg-block" data-aos="fade-left">
            <img
              src={fundacionNicanImg}
              alt="Capacitación Fundación Nican | Ixtapaluca, Estado de México"
              className="about-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutUs;
